import {
    areaFixedLayerIds,
    knownRouteFixedLayerIds,
    publicTrackFixedLayerIds,
    trackFixedLayerIds,
    waypointFixedLayerIds,
} from '@gaia/utils/gaia/getSyncMapboxStyle/fixedLayerIds';
import includesDeep from '@gaia/utils/includesDeep';
import endsWith from 'lodash/endsWith';

export default {
    poiCluster: (feature: mapboxgl.MapboxGeoJSONFeature) =>
        endsWith(feature.layer.id, 'poi-clusters') ||
        endsWith(feature.layer.id, 'poi-clusters-minzoom'),

    osm: (feature: mapboxgl.MapboxGeoJSONFeature) => {
        if (!feature.properties || !feature.properties.osm_id) return false;
        if (feature.geometry.type === 'Polygon') return false;
        if (feature.geometry.type === 'MultiPolygon') return false;
        return true;
    },

    knownRoute: (feature: mapboxgl.MapboxGeoJSONFeature) =>
        includesDeep(knownRouteFixedLayerIds, feature.layer.id),

    // Public tracks taken local are saved to tracks with the property isPublicTrack: true.
    track: (feature: any): feature is Track =>
        includesDeep(trackFixedLayerIds, feature.layer.id) && !feature.properties?.isPublicTrack,

    publicTrack: (feature: any): feature is Track =>
        feature.properties?.isPublicTrack ||
        includesDeep(publicTrackFixedLayerIds, feature.layer.id),

    waypoint: (feature: any): feature is Waypoint =>
        includesDeep(waypointFixedLayerIds, feature.layer.id),

    area: (feature: any): feature is Area => includesDeep(areaFixedLayerIds, feature.layer.id),

    interactionSpec: (
        feature: mapboxgl.MapboxGeoJSONFeature,
        mapboxStyle: GaiaMapboxStyle | undefined
    ) => {
        if (!mapboxStyle?.['interaction-layers']) return false;
        if (mapboxStyle['interaction-layers'].indexOf(feature.layer.id) === -1) return false;
        return true;
    },
};
